import React from 'react';

import { useIsLoggedInSession } from './useIsLoggedInSession';
import { useJarabotLoginOffers } from './useJarabotLoginOffers';

function LoggedInJarabotLoginOffers(): null {
	useJarabotLoginOffers();

	return null;
}

function JarabotLoginOffers(): JSX.Element | null {
	const isLoggedInSession = useIsLoggedInSession();

	if (!isLoggedInSession) return null;

	return <LoggedInJarabotLoginOffers />;
}

export default JarabotLoginOffers;
